import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { CustomPrice } from '../../../common/order/customPrice'
import {
  selectDiscountInfo,
  selectNumberOfCompany,
  selectScreeningPrice,
} from '../../../tool/screening/exportFileSetting/store/slice'
import { CHECKBOX_TRADE_DISCOUNT } from '../../constant'
import { formatPrice } from '../../helper'
import classes from '../../index.module.scss'
import {
  selectCheckDisCountAndVoucher,
  selectDiscountOrder,
  selectTotalPrice,
  selectVoucher,
} from '../../store/slice'
import { getDiscount } from '../../store/thunk'

const Price = ({ isScreening, vatPercentage }) => {
  const dispatch = useDispatch()
  const discountedPrice = useSelector(selectTotalPrice('discountedPrice'))
  const dataVoucher = useSelector(selectVoucher)
  const discountOrder = useSelector(selectDiscountOrder)
  const checkDiscountAndVoucher = useSelector(selectCheckDisCountAndVoucher)
  const screeningPrice = useSelector(selectScreeningPrice)
  const discountInfo = useSelector(selectDiscountInfo)
  const numberOfCompany = useSelector(selectNumberOfCompany)

  //Screening
  const originUnitPrice = screeningPrice?.price
  const discountUnitPrice =
    screeningPrice?.price * (1 - screeningPrice?.discountPercentage)
  const price = (discountUnitPrice || originUnitPrice) * numberOfCompany
  const discountOrderPriceScreening =
    (discountInfo?.typeRadio && discountInfo?.percentageVoucher
      ? price * discountInfo?.percentageVoucher
      : 0) + (price * discountOrder?.discountPercentage || 0)

  const priceVATScreening = Math.max(
    0,
    (price - discountOrderPriceScreening) * vatPercentage,
  )
  const totalPriceScreening = Math.max(
    0,
    price - discountOrderPriceScreening + priceVATScreening,
  )

  //Other
  const priceDiscountRaw = checkDiscountAndVoucher[
    CHECKBOX_TRADE_DISCOUNT.DISCOUNT
  ]
    ? discountedPrice * discountOrder?.discountPercentage
    : 0
  const priceVoucher = checkDiscountAndVoucher[CHECKBOX_TRADE_DISCOUNT.VOUCHER]
    ? discountedPrice * dataVoucher?.discountPercentage ||
      dataVoucher?.discountAmount
    : 0
  const priceDiscount = formatPrice(priceDiscountRaw + priceVoucher)

  const priceVAT = (discountedPrice - priceDiscount) * vatPercentage
  const priceTotalFinal = discountedPrice - priceDiscount + priceVAT

  useEffect(() => {
    if (isScreening) {
      dispatch(getDiscount())
    }
  }, [])

  return (
    <Element className={classes.priceContainer}>
      <div className="dFlex alignItemsCenter justifyContentBetween">
        <div className="fw600 dFlex alignItemsCenter">
          <div>
            <Translate value="cartAndOrders.cart.tradeDiscount" />
            &nbsp;&nbsp;
          </div>
        </div>
        <CustomPrice
          value={isScreening ? discountOrderPriceScreening : priceDiscount}
          style={{
            color: '#0553A5',
            fontSize: 14,
            fontWeight: 600,
          }}
          styleIcon={{ width: 18, height: 18 }}
        />
      </div>
      <div className="mt1 dFlex alignItemsCenter justifyContentBetween">
        <div className="fw600 dFlex alignItemsCenter">
          <div>VAT &nbsp;&nbsp;</div>
        </div>
        <CustomPrice
          value={Math.max(isScreening ? priceVATScreening : priceVAT, 0)}
          style={{
            color: '#0553A5',
            fontSize: 14,
            fontWeight: 600,
          }}
          styleIcon={{ width: 18, height: 18 }}
        />
      </div>
      <div className="mt1 dFlex alignItemsCenter justifyContentBetween">
        <div className="dFlex">
          <div className="fw600">
            <Translate value="cartAndOrders.main.total" />
            &nbsp;
          </div>
        </div>
        <CustomPrice
          value={Math.max(
            isScreening ? totalPriceScreening : priceTotalFinal,
            0,
          )}
          style={{
            color: '#3DA967',
            fontSize: 14,
            fontWeight: 600,
          }}
          styleIcon={{ width: 18, height: 18 }}
        />
      </div>
    </Element>
  )
}

export default Price
